import initialState from './initialState.js';
import constants from '../helpers/constants.js';

export default function meReducer(state = initialState.meData, action) {
    switch (action.type) {
        case constants.GET_CUSTOMER_DETAILS_SUCCESS:
            return Object.assign({}, state, { customerPreferences: action.data });
        case constants.SET_DISTRIBUTOR_VALUE:
            return Object.assign({}, state, { distributor: action.data });
        case constants.USER_INFO_SUCCESS:
            return Object.assign({}, state, { user: action.data });
        case constants.SET_LANGUAGE:
            return Object.assign({}, state, { selectedLanguage: action.data });
        case constants.SET_DEFAULT_CUSTOMER:
            return Object.assign({}, state, {
                defaultCustomer: action.data.customer,
                customer: action.data.customer,
                roles: action.data.roles,
            });
        case constants.SET_USER_TYPE:
            return Object.assign({}, state, { isInternal: action.data });
        case constants.USER_PERMISSIONS_SUCCESS:
            return Object.assign({}, state, {
                contracts: action.data.customer.contracts,
                customer: action.data.customer,
                customerId: action.data.customer.id,
                roles: action.data.roles,
            });
        case constants.SET_DEFAULT_CONTRACTS:
            return updateContract(state, action.data);
        case constants.ME_STATE_UPDATE:
            return Object.assign({}, state, { meState: action.data });
        case constants.USER_RESOURCE_RIGHT:
            return Object.assign({}, state, { resourceAccess: action.data });
        case constants.CUSTOMER_INFO_SUCCESS:
            return Object.assign({}, state, { manageCustomerList: action.data });
        case constants.UPDATE_LANGUAGE:
            return Object.assign({}, state, {
                user: Object.assign({}, state.user, { culture: action.data }),
            });
        case constants.UPDATE_HYPHENIZED_CULTURE:
            return Object.assign({}, state, { hyphenizedCulture: action.data });
        case constants.SET_SUPPORTED_SUPPLIERS:
            return { ...state, supportedSuppliers: action.payload };
        case constants.SET_SUBMISSION_DETAILS:
            return Object.assign({}, state, {
                submissionDetails: { submissionId: action.payload },
            });
        default:
            return state;
    }
}

function updateContract(state, data) {
    state.customer.supplierCustomerContracts = data;
    return state;
}
